module.exports = __webpack_public_path__ + "img/activityApplicationIcon.607a99d9.png";